import React from 'react'

import classes from './common.module.scss'

export const Center = (props: any) => <div className={classes.center} {...props} />

export const Input = (props: any) => <input className={classes.input} {...props} />
